/**
 * Ответы опроса статуса генерации — всей странице (28.09).
 *
 * Статус генерации спрашивают несколько мест (ожидание виджета и студии, стикеры, глобальный опрос после
 * перезагрузки), а «провайдер не пропустил звук — пересоздаём ролик» надо показать там, где генерацию видно. Вместо
 * протаскивания через все слои каждый ответ getTaskStatus кладётся сюда: кто рисует генерацию, берёт её последнее
 * состояние по номеру (taskTick) и перерисовывается на каждый ответ (hooks/useTaskTicks).
 */
import type { TaskStatusResponse } from './images'

export const TASK_TICK_EVENT = 'umnik:task-status'

export interface TaskTick {
	/** Провайдер не пропустил звук готового ролика — сервер пересоздаёт его (генерация идёт, списано один раз). */
	retrying: boolean
	/** Номер идущей попытки (1 — первая). */
	attempt: number | null
}

/** Подпись для клиента, пока сервер пересоздаёт ролик. */
export const RETRY_TITLE = 'Пересоздаём ролик'
export const RETRY_NOTE = 'дольше обычного, бесплатно'

const ticks = new Map<string, TaskTick>()

export function reportTaskStatus(s: TaskStatusResponse | null | undefined): void {
	if (!s?.request_id) return
	ticks.set(s.request_id, { retrying: !!s.retrying, attempt: s.attempt ?? null })
	if (typeof window !== 'undefined') window.dispatchEvent(new Event(TASK_TICK_EVENT))
}

/** Последний ответ сервера по генерации; null — ещё не отвечал. */
export function taskTick(requestId: string | null | undefined): TaskTick | null {
	return (requestId && ticks.get(requestId)) || null
}
